var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 67,
    viewBox: "0 0 338 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12579_12985)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8051 9.53613L4.35474 14.6605L14.1475 22.4378L20.5978 17.317L10.8051 9.53613Z",
    fill: "#F6851F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2857 17.0669C18.506 15.6528 15.6241 15.6528 13.8487 17.0633C12.0735 18.4739 12.0734 20.763 13.8532 22.1771C15.6329 23.5911 18.5149 23.5911 20.2902 22.1806C22.0699 20.77 22.0655 18.4809 20.2857 17.0669Z",
    fill: "#F6851F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0716 11.8604H2.94727V63.7369H12.0716V11.8604Z",
    fill: "#F8961D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9162 32.6914L4.85338 60.5355C3.70232 61.1971 2.94971 62.2752 2.94971 63.4898C2.94971 65.5023 5.0039 67.1335 7.54064 67.1335C8.65628 67.1335 9.67895 66.8184 10.4758 66.2899L10.4935 66.3039L46.371 37.8122L39.9162 32.6914Z",
    fill: "#E01F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5855 36.0007C48.1175 34.0486 46.5569 32.1267 44.0998 31.7081C41.6427 31.2894 39.2195 32.5327 38.6876 34.4848C38.1555 36.4368 39.7161 38.3586 42.1731 38.7772C44.6303 39.1958 47.0534 37.9527 47.5855 36.0007Z",
    fill: "#CA2127"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51786 8.45117C5.00767 8.45117 2.97119 10.0718 2.97119 12.0703C2.97119 14.069 5.00767 15.6896 7.51786 15.6896C10.028 15.6896 12.0645 14.069 12.0645 12.0703C12.0689 10.0718 10.0325 8.45117 7.51786 8.45117Z",
    fill: "#F8961D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2299 45.2812L45.7839 50.402L55.5723 58.1795L62.0227 53.0587L52.2299 45.2812Z",
    fill: "#2C9C48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5287 45.5473C50.749 44.1332 47.8714 44.1332 46.0961 45.5439C44.3208 46.9544 44.3252 49.2436 46.1005 50.6542C47.8802 52.0683 50.7579 52.0683 52.5332 50.6576C54.3129 49.247 54.3085 46.9579 52.5287 45.5473Z",
    fill: "#2C9C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4307 3.98926H54.3108V55.8552H63.4307V3.98926Z",
    fill: "#4CB853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8422 0.59375C57.7264 0.59375 56.7039 0.908769 55.9114 1.4373L55.8937 1.4233L20.0383 29.908L26.4842 35.0288L61.525 7.19164C62.676 6.5301 63.4286 5.45203 63.4286 4.23747C63.4286 2.22485 61.3745 0.59375 58.8422 0.59375Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.727 33.1864C28.2249 31.2287 26.631 29.324 24.1668 28.9323C21.7027 28.5405 19.3015 29.81 18.8035 31.7677C18.3055 33.7254 19.8995 35.6301 22.3637 36.0218C24.8279 36.4136 27.2291 35.1441 27.727 33.1864Z",
    fill: "#1E9680"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8594 52.0293C56.3492 52.0293 54.3127 53.6499 54.3127 55.6484C54.3127 57.6471 56.3492 59.2677 58.8594 59.2677C61.3696 59.2677 63.406 57.6471 63.406 55.6484C63.406 53.6499 61.3696 52.0293 58.8594 52.0293Z",
    fill: "#4CB853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5581 43.9865V19.166H87.9883L94.9462 31.0808L101.939 19.166H105.334V43.9865H102.892V29.8966L102.962 22.2998H102.662L95.308 34.7463H94.4174L87.1952 22.2998H86.9308L86.9655 29.8966V43.9865H84.5581Z",
    fill: "#F6851F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.834 43.9865H112.918V19.166H126.34V21.6069H115.395V29.8161H125.255V32.2651H115.395V41.5053H126.834V43.9865Z",
    fill: "#F6851F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.887 33.4085V31.04H152V41.545C149.671 43.5053 146.77 44.4855 143.295 44.4855C141.292 44.4855 139.472 44.0021 137.834 43.0354C136.197 42.0633 134.86 40.5864 133.827 38.6046C132.796 36.6174 132.282 34.2759 132.282 31.5798C132.282 27.8096 133.381 24.7161 135.579 22.2993C137.779 19.8771 140.471 18.666 143.658 18.666C146.715 18.666 149.352 19.5065 151.569 21.1875L150.518 23.4432C148.56 21.8911 146.274 21.115 143.658 21.115C140.976 21.115 138.822 22.0952 137.194 24.0554C135.566 26.0157 134.751 28.5239 134.751 31.5798C134.751 34.7109 135.598 37.2297 137.291 39.1363C138.985 41.0482 141.095 42.0043 143.623 42.0043C145.909 42.0043 147.922 41.4188 149.662 40.2481V33.4085H143.887Z",
    fill: "#F6851F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.102 43.9865L167.369 19.166H170.271L179.505 43.9865H176.902L173.833 35.6245H163.641L160.642 43.9865H158.102ZM168.984 22.1064H168.524L164.504 33.2559H172.978L168.984 22.1064Z",
    fill: "#F6851F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82 21.1875L201.797 23.4834C199.775 21.9046 197.665 21.115 195.465 21.115C192.831 21.115 190.668 22.0952 188.974 24.0554C187.281 26.0157 186.435 28.5105 186.435 31.5396C186.435 34.7726 187.274 37.2996 188.953 39.1203C190.637 40.9408 192.799 41.8512 195.438 41.8512C196.82 41.8512 198.001 41.6901 198.98 41.3679C199.958 41.051 201.008 40.4736 202.131 39.6358L202.855 42.1573C200.791 43.7094 198.198 44.4855 195.076 44.4855C193.625 44.4855 192.244 44.2224 190.936 43.696C189.628 43.1751 188.446 42.399 187.388 41.3679C186.335 40.3366 185.5 38.9752 184.883 37.2834C184.267 35.5917 183.958 33.677 183.958 31.5396C183.958 27.7693 185.073 24.6812 187.305 22.275C189.535 19.8691 192.256 18.666 195.465 18.666C198.347 18.666 200.798 19.5065 202.82 21.1875Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.459 29.7839V19.166H226.929V43.9865H224.459V32.2248H211.928V43.9865H209.451V19.166H211.928V29.7839H224.459Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.198 43.9865L242.466 19.166H245.368L254.6 43.9865H251.998L248.93 35.6245H238.736L235.737 43.9865H233.198ZM244.08 22.1064H243.621L239.599 33.2559H248.074L244.08 22.1064Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.869 43.9865V19.166H269.281C271.433 19.166 273.187 19.7836 274.541 21.0189C275.891 22.2541 276.566 23.9271 276.566 26.0377C276.566 27.4879 276.132 28.8117 275.265 30.0094C274.397 31.2071 273.17 32.0475 271.584 32.5309L278.083 43.9865H275.084L269.079 33.0304H263.339V43.9865H260.869ZM268.78 21.6069H263.339V30.5492H268.815C270.397 30.5492 271.672 30.1598 272.641 29.3811C273.611 28.6023 274.096 27.4879 274.096 26.0377C274.096 23.0839 272.324 21.6069 268.78 21.6069Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.308 33.4085V31.04H302.421V41.545C300.092 43.5053 297.191 44.4855 293.717 44.4855C291.718 44.4855 289.898 44.0021 288.256 43.0354C286.617 42.0633 285.282 40.5864 284.248 38.6046C283.218 36.6174 282.703 34.2759 282.703 31.5798C282.703 27.8096 283.802 24.7161 286 22.2993C288.2 19.8771 290.892 18.666 294.079 18.666C297.135 18.666 299.775 19.5065 301.997 21.1875L300.94 23.4432C298.981 21.8911 296.695 21.115 294.079 21.115C291.397 21.115 289.243 22.0952 287.615 24.0554C285.987 26.0157 285.172 28.5239 285.172 31.5798C285.172 34.7109 286.019 37.2297 287.713 39.1363C289.406 41.0482 291.516 42.0043 294.044 42.0043C296.331 42.0043 298.343 41.4188 300.083 40.2481V33.4085H294.308Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.76 43.9865H309.845V19.166H323.267V21.6069H312.315V29.8161H322.174V32.2651H312.315V41.5053H323.76V43.9865Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.322 13.6775V16.2168H325.755V13.6775H326.322ZM327.095 13.6775V14.1187H324.998V13.6775H327.095ZM327.647 13.6775H328.118L328.729 15.493L329.337 13.6775H329.808L328.919 16.2168H328.537L327.647 13.6775ZM327.375 13.6775H327.855L327.944 15.5593V16.2168H327.375V13.6775ZM329.601 13.6775H330.082V16.2168H329.512V15.5593L329.601 13.6775Z",
    fill: "#28A992"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.599,
    cy: 14.8274,
    r: 3.52209,
    stroke: "#28A992",
    strokeWidth: 0.634052
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12579_12985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dca4fb32be8888f2e0fe20c4d69b193f.svg";
export { ForwardRef as ReactComponent };